// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"633792bf","461":"2a811ee7","849":"6132616c"}[chunkId] + ".chunk.css";
};